// Re-export from radix toast hook pattern
// In a full implementation this connects to the Toaster provider.
// Simple implementation using event bus for now.

import { useState, useEffect } from 'react'

export interface Toast {
  id: string
  title: string
  description?: string
  variant?: 'default' | 'destructive'
}

type ToastInput = Omit<Toast, 'id'>

const listeners: Array<(toast: Toast) => void> = []

function emitToast(input: ToastInput) {
  const toast: Toast = { ...input, id: Math.random().toString(36).slice(2) }
  listeners.forEach((l) => l(toast))
}

export function useToastListener() {
  const [toasts, setToasts] = useState<Toast[]>([])

  useEffect(() => {
    function handler(t: Toast) {
      setToasts((prev) => [...prev, t])
      setTimeout(() => {
        setToasts((prev) => prev.filter((x) => x.id !== t.id))
      }, 4000)
    }
    listeners.push(handler)
    return () => {
      const i = listeners.indexOf(handler)
      if (i >= 0) listeners.splice(i, 1)
    }
  }, [])

  return toasts
}

export function useToast() {
  return { toast: emitToast }
}
